import React, { useEffect, useState, useContext } from "react";
import { Box, Typography, CircularProgress, useTheme, TextField, Button } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { tokens } from "../../theme";
import { learncardsContext } from "../../App";
import { API, Auth } from "aws-amplify";

const Users = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { loading, setLoading, userInfo, setUserInfo } = useContext(learncardsContext);

  const [newUser, setNewUser] = useState("");

  const columns = [
    { field: 'email', headerName: 'Email', flex: 1 },
    {
      field: 'role',
      headerName: 'Rol',
      flex: 1,
      valueGetter: (params) => params.row.role === 'L1' ? 'Student' : params.row.role === 'L2' ? 'Coach' : params.row.role
    },
  ];



  const handleAddUser = async () => {
    try {
      const session = await Auth.currentSession();
      const accessToken = session.getAccessToken().getJwtToken();
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      };
      const response = await API.post("FRONTEND_HTTP_API", "/createUser", {
        body: { email: newUser },
        headers,
      });
      console.log("Added user successful:", response);
      //add the new user to the userInfo.users array
      setUserInfo({
        ...userInfo,
        users: [...userInfo.users, { username: newUser, email: newUser, role: "L1" }],
      });
      //show a message to the user that the user has been added
      alert("Gebruiker succesvol toegevoegd.");

    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  return (
    <Box m="20px">
      {/* <Typography variant="h2" color={colors.grey[100]} fontWeight="bold" mb="5px">
        Gebruikers
      </Typography> */}
      {/* New input box for adding a new set */}
      <Box display="flex" alignItems="center" mb="20px">
        <TextField
          label="email"
          value={newUser}
          onChange={(e) => setNewUser(e.target.value)}
          sx={{ width: '300px', mr: 2 }} // Adjust width as needed
        />
        <Button variant="contained" onClick={handleAddUser}>
          Voeg student toe
        </Button>
      </Box>
      <Typography variant="h5" color={colors.greenAccent[400]}>
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ flexGrow: 1, width: '100%' }}>
          {userInfo.users && userInfo.users.length > 0 ? (
            <DataGrid
              rows={userInfo.users}
              columns={columns}
              pagination='false'
              getRowId={(row) => row.email}
              sx={{
                '& .MuiDataGrid-main': { width: '100%' },
                '& .MuiDataGrid-cell': { maxWidth: 'unset !important' },
                '& .MuiDataGrid-columnHeaders': {
                  maxWidth: 'unset !important',
                  backgroundColor: 'rgb(223, 84, 42,0.7)',
                  color: 'black',
                  //fontSize: '1.0rem',
                  //make font super bold with extra font weight
                  fontWeight: 'bold',
                  fontSize: '1.0rem',
                },
                '& .MuiDataGrid-columnHeader': {
                  borderRight: `1px solid ${colors.primary[200]}`,
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  padding: '0 16px',
                },
              }}
            />
          ) : (
            <Typography>Geen gebruikers gevonden.</Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Users;